export const DEFAULT_STORAGE = 'localStorage';
export const STORAGE_NAME = 'sofarm2.0';

export const getStorage = (name, type = DEFAULT_STORAGE) =>
  window[type].getItem(name) ? JSON.parse(window[type].getItem(name)) : {};

export const setStorageItem = (name, value, type = DEFAULT_STORAGE) => {
  const storage = getStorage(STORAGE_NAME);
  const newStorage = Object.assign(storage, { [name]: value });

  window[type].setItem(STORAGE_NAME, JSON.stringify(newStorage));
};

export const getStorageItem = (name) => {
  const storage = getStorage(STORAGE_NAME) || {};

  return storage[name];
};

export const removeStorageItem = (name, type = DEFAULT_STORAGE) => {
  const storage = getStorage(STORAGE_NAME) || {};

  delete storage[name];

  window[type].setItem(STORAGE_NAME, JSON.stringify(storage));
};

export default {
  getStorage,
  setStorageItem,
  getStorageItem,
  removeStorageItem,
};



// WEBPACK FOOTER //
// ./src/common/utils/StorageApi.js